<template>
  <base-icon
    v-on="$listeners"
    v-bind="$attrs"
    :transform-function="getSettlementObjectOwnerEmailStatus"
    :icon="(value) => value.sent ? 'mdi-email-check' : 'mdi-email-send'"
    :color="(value) => value.iconColor"
    :translate="false"
    :title="(value) => trans(value.titleMessageKey, value.titleMessageParams)"
  />
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon';
import {LocaleUtils} from '@/utils/locale-utils';
import {DateUtils} from '@/utils/date-utils';
export default {
  name: 'SettlementOwnerEmailIcon',
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  components: {BaseIcon},
  methods: {
    /** @param settlementObject {SettlementObjectDto} */
    getSettlementObjectOwnerEmailStatus (settlementObject) {
      if(typeof settlementObject === 'boolean') {
        settlementObject = {
          sent: settlementObject
        }
      }

      let statusData = {
        sent: false,
        titleMessageKey: 'settlement.titleIsNotSent',
        titleMessageParams: null,
        iconColor: null
      };

      if (settlementObject.sent) {
        statusData.sent = true;
        statusData.titleMessageKey = settlementObject.lastOwnerEmail != null ? 'settlement.titleIsSent' : 'settlement.titleIsUnknownSent';
        statusData.iconColor = 'success';
        statusData.titleMessageParams = {
          successfullySentAt: settlementObject.lastOwnerEmail != null ? this.formatDate(settlementObject.lastOwnerEmail.successfullySentAt, 'LLL') : '?'
        };
      } else if (settlementObject.lastOwnerEmail) {
        if (settlementObject.lastOwnerEmail.status === 'PENDING' || settlementObject.lastOwnerEmail.status === 'SENDING') {
          statusData.titleMessageKey = 'email.titleStatusPending';
          statusData.iconColor = '#E6C091';
        } else if (settlementObject.lastOwnerEmail.status === 'ERROR') {
          statusData.titleMessageKey = 'email.titleStatusFailed';
          statusData.iconColor = 'error';
        }
      }

      return statusData;
    },
  }
}
</script>

<style scoped>

</style>
